import { defineComponent as _defineComponent } from 'vue'
import { PropType, watch, ref } from 'vue';
import { useModelValue } from "../../../composables/useSyncProp";
import { FifScript } from './FIFSurvey/FifScripts';
import { questions } from './FIFSurvey/questions';
import FIFSurveyForm from './FIFSurvey/FIFSurveyForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FIFProcessResults',
  props: {
	value: {
		type: Boolean as PropType<boolean>,
		required: true,
	},
	scripts: {
		type: Object as () => Record<FifScript, boolean>,
		required: false,
	},
},
  emits: ["input", "qrs-confirmed", "sme-confirmed", "scriptFinished"],
  setup(__props, { emit }: { emit: ({
	(event: 'input', value: boolean): void
	(event: 'qrs-confirmed', value: any): void
	(event: 'sme-confirmed', value: any): void
	(event: 'scriptFinished', value: FifScript): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const surveyForm = ref(null)
const doShow = useModelValue(props, emit)

watch(doShow, (newVal) => {
	if (!newVal) {
		surveyForm.value?.reset?.()
	}
})

return { __sfc: true,props, emit, surveyForm, doShow, questions, FIFSurveyForm }
}

})